import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal } from 'antd'
import AuditJobFairApplication from './audit'
import EditJobFairApplication from './edit'

const JobFairApplicationDetail = (props) => {
    const [applicationDetail, setApplicationDetail] = useState({})
    const [propsData, setPropsData] = useState({})
    const [isAuditVisible, setIsAuditVisible] = useState(false)
    const [isEditVisible, setIsEditVisible] = useState(false)

    const getJobFairDetail = () => {
        axios.post('/admin/job_fair/detail', {
            application_id: props.data.id
        })
            .then(function (response) {
                if (response.errcode === 0) {
                    setApplicationDetail(response.data)
                }
            })
            .catch(function (error) {
                console.error('请求失败：', error)
            })
    }

    useEffect(() => {
        getJobFairDetail()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data.id])

    const handleCancel = () => {
        props.isCancel()
    }

    const getColor = () => {
        if (applicationDetail.audit_status === 2) return 'green'
        if (applicationDetail.audit_status === 3) return 'red'
        return 'black'
    }

    const getAuditText = () => {
        if (applicationDetail.audit_status === 2) return '通过'
        if (applicationDetail.audit_status === 3) return '拒绝'
        return '待审核'
    }

    const openAudit = () => {
        setIsAuditVisible(true)
        setPropsData({
            id: applicationDetail.id,
            auditStatus: applicationDetail.audit_status,
            failureReason: applicationDetail.audit_remark
        })
    }

    const openEdit = () => {
        setIsEditVisible(true)
        setPropsData({
            application_id: applicationDetail.id
        })
    }

    const CAMPUS_MAP = {
        1: '兰州职业技术学院',
        2: '雁儿湾校区',
        3: '桃林校区'
    }

    const printPdf = (url) => {
        window.open(url, '_blank')
    }

    return (
        <Modal
            title="宣讲会申请详情"
            width='700px'
            open={props.isOpen}
            onCancel={handleCancel}
            footer={false}>

            <div className='public-datail-container'>

                <div className='public-datail-item'>
                    <div className='public-datail-label'>企业名称</div>
                    <div className='public-datail-content'>{applicationDetail.company_name}</div>
                </div>

                <div className='public-datail-item'>
                    <div className='public-datail-label'>所在区域</div>
                    <div className='public-datail-content'>{applicationDetail.region}</div>
                </div>

                <div className='public-datail-item'>
                    <div className='public-datail-label'>公司性质</div>
                    <div className='public-datail-content'>{applicationDetail.company_type}</div>
                </div>

                <div className='public-datail-item'>
                    <div className='public-datail-label'>是否500强或行业龙头</div>
                    <div className='public-datail-content'>
                        {applicationDetail.is_top_company ? '是' : '否'}
                    </div>
                </div>

                <div className='public-datail-item'>
                    <div className='public-datail-label'>招聘对应二级学院</div>
                    <div className='public-datail-content'>{applicationDetail.college}</div>
                </div>

                <div className='public-datail-item'>
                    <div className='public-datail-label'>招聘专业</div>
                    <div className='public-datail-content'>
                        {applicationDetail.majors && applicationDetail.majors.join(' ｜ ')}
                    </div>
                </div>

                <div className='public-datail-item'>
                    <div className='public-datail-label'>招聘人数</div>
                    <div className='public-datail-content'>{applicationDetail.recruitment_count}</div>
                </div>

                <div className='public-datail-item'>
                    <div className='public-datail-label'>岗位说明</div>
                    <div className='public-datail-content'>{applicationDetail.job_description}</div>
                </div>

                <div className='public-datail-item'>
                    <div className='public-datail-label'>企业联系人</div>
                    <div className='public-datail-content'>{applicationDetail.contact_name}</div>
                </div>

                <div className='public-datail-item'>
                    <div className='public-datail-label'>联系人职务</div>
                    <div className='public-datail-content'>{applicationDetail.contact_title}</div>
                </div>

                <div className='public-datail-item'>
                    <div className='public-datail-label'>联系电话</div>
                    <div className='public-datail-content'>{applicationDetail.contact_phone}</div>
                </div>

                <div className='public-datail-item'>
                    <div className='public-datail-label'>预约资源</div>
                    <div className='public-datail-status'>
                        {CAMPUS_MAP[applicationDetail.campus]}｜{applicationDetail.date}｜{applicationDetail.venue}
                    </div>
                    <div className='public-datail-button' onClick={openEdit} style={{flexShrink: 0, marginLeft: 10 }}>重选</div>
                </div>

                <div className='public-datail-item'>
                    <div className='public-datail-label'>审核状态</div>
                    <div style={{ color: getColor() }} className='public-datail-status'>
                        {getAuditText()}
                    </div>
                    <div className='public-datail-button' onClick={openAudit}>审核</div>
                </div>

                {applicationDetail.audit_status !== 1 && <>
                    <div className='public-datail-item'>
                        <div className='public-datail-label'>审核人</div>
                        <div className='public-datail-content'>{applicationDetail.audit_person || '-'}</div>
                    </div>
                    <div className='public-datail-item'>
                        <div className='public-datail-label'>审核时间</div>
                        <div className='public-datail-content'>{applicationDetail.audit_time}</div>
                    </div>
                    <div className='public-datail-item'>
                        <div className='public-datail-label'>审核备注</div>
                        <div className='public-datail-content'>{applicationDetail.audit_remark || '-'}</div>
                    </div>
                </>}
                {applicationDetail.audit_status === 2 && <>
                    <div className='public-datail-item'>
                        <div className='public-datail-label'>邀请函</div>
                        <div className='public-datail-pdf'>
                        <iframe 
                            title='邀请函'
                            style={{border: 'none', width: '99px', height: '140px'}} 
                            src={applicationDetail.invitation_letter}>
                        </iframe>
                        <div className='public-datail-button2' onClick={() => {printPdf(applicationDetail.invitation_letter)}}>预览</div>
                        </div>
                    </div>
                </>}
            </div>

            {isAuditVisible && <AuditJobFairApplication
                data={propsData}
                getJobFairDetail={getJobFairDetail}
                getApplicationData={() => { props.getApplicationData() }}
                isOpen={isAuditVisible}
                isCancel={() => { setIsAuditVisible(false) }}
            />}

            {isEditVisible && <EditJobFairApplication
                data={propsData}
                getJobFairDetail={getJobFairDetail}
                getApplicationData={() => { props.getApplicationData() }}
                isOpen={isEditVisible}
                isCancel={() => { setIsEditVisible(false) }}
            />}
        </Modal>
    )
}

export default JobFairApplicationDetail